import React from 'react';
import RoleMultiSelectWithCheckList from './RoleMultiSelectWithCheckList';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import { MenuPlacement } from '../../../Enums/MenuPlacement.enum';

interface Props extends BaseFieldProps {
	excludeRoleKeys?: string[];
	includeRoleKeys?: string[];
	menuPlacement?: MenuPlacement;
}

const RoleMultiSelectWithCheckListField: React.FC<Props> = props => (
	<BaseField {...props}>
		<RoleMultiSelectWithCheckList
			excludeRoleKeys={props.excludeRoleKeys}
			includeRoleKeys={props.includeRoleKeys}
			menuPlacement={props.menuPlacement}
		/>
	</BaseField>
);

export default RoleMultiSelectWithCheckListField;
